// extracted by mini-css-extract-plugin
export default {"Package":"Tohdru59btOPqHyCk1xn"};